<template>
  <MenuItem
    v-if="!hideMenu && (prolong || return_to_site) && !tender.isUrgent"
    class="h11-links"
    :data-qa="`item-${return_to_site ? 'back-to' : 'continue'}`"
    :disabled="$acl.check('noAccess')"
    icon="continue"
    :label="`${return_to_site ? $t('Tenders.BackTo') : $t('Tenders.Continue')} ${return_to_status}`"
    @click="open">
    <template #after>
      <DialogTemplateToolkit
        :dialog="dialog"
        :disabled="sendApi"
        first_btn="Tenders.Continue"
        :loading="loading"
        second_btn="Common.Cancel"
        :title="`${$t('Tenders.TenderProlongation')} #${tender.tenderNumber}   ${tender.tenderSubject || tender.title}`"
        @apply="submit"
        @close="cancel">
        <template #card-text>
          <sForm
            ref="prolongTenderForm"
            :disabled="sendApi"
            label-position="top"
            label-width="100px"
            :model="formData"
            :rules="rules">
            <div class="flex flex-between">
              <div class="width-100">
                <sFormItem
                  ref="formItemProposalDate"
                  prop="proposal.date">
                  <template #default="{ error }">
                    <TermsCard
                      ref="dates"
                      :end-date.sync="formData.proposal.date"
                      :end_date_error="!!error"
                      end_date_text="Tenders.UpdatedEndDate"
                      :end_date_title="false"
                      :inner-validate="false"
                      :minimal-date="pickerMinDate"
                      :publish_btn="false"
                      :time.sync="formData.proposal.time"
                      :use-date-range="false"
                      @update:endDate="val => sendChangeFormItem('formItemProposalDate', val)">
                      <template #second_name>
                        <div class="h8-text pb-3 px-0">
                          {{ $t('Tenders.UpdatedDeliveryTerms') }}
                        </div>
                      </template>
                    </TermsCard>
                  </template>
                </sFormItem>
                <DateRangeDialog
                  :disabled="sendApi"
                  :options="deliveryDateOptions"
                  :search.sync="deliveryDate.arrayDate"
                  :show-periods="false"
                  @apply="setDeliveryDate">
                  <template #activator="{ on, open: openActivator }">
                    <div>
                      <div class="h8-text pl-3">
                        {{ $t('Tenders.UpdatedDeliveryTerms') }}
                      </div>
                      <div class="flex">
                        <sFormItem
                          ref="formItemDeliveryDateFrom"
                          prop="deliveryDate.from">
                          <template #default="{ error }">
                            <DateChip
                              data-qa="date_chip_from"
                              :date="deliveryDate.fromLabel"
                              :disabled="sendApi"
                              :error="!!error"
                              :on="on"
                              :placeholder="$t('Tenders.ForStartOfDelivery')"
                              @click="openActivator"/>
                          </template>
                        </sFormItem>
                        <sFormItem
                          ref="formItemDeliveryDateTo"
                          class="ml-6"
                          prop="deliveryDate.to">
                          <template #default="{ error }">
                            <DateChip
                              data-qa="date_to_format"
                              :date="deliveryDate.toLabel"
                              :disabled="sendApi"
                              :error="!!error"
                              :on="on"
                              :placeholder="$t('Tenders.ForEndOfDelivery')"
                              @click="openActivator"/>
                          </template>
                        </sFormItem>
                      </div>
                    </div>
                  </template>
                </DateRangeDialog>
              </div>
              <sAlert
                v-if="isReturnToAuction && !auction_endDate"
                class="ml-3"
                type="warning">
                {{ $t('Tenders.HintReturnToAuction') }}
              </sAlert>
            </div>
            <sFormItem
              :class="{'is-required': !isRepublish}"
              prop="text">
              <span
                slot="label"
                class="black--text h7-text medium pb-3 ">{{ $t('Tenders.WhyProlong') }}</span>
              <div class="flex">
                <sInput
                  clearable
                  :placeholder="$t('Tenders.WhyProlong')"
                  show-word-limit
                  trim
                  type="textarea"
                  :value.sync="formData.text"/>
                <div
                  class="secondary__green_chosen px-3 py-3 ml-3"
                  style="width: 300px; border-radius: 8px;">
                  <span class="h7-text"> {{ $t('Tenders.ProlongReason') }} </span>
                </div>
              </div>
            </sFormItem>
          </sForm>
        </template>
      </DialogTemplateToolkit>
      <ProlongTenderWithForeignOffers
        ref="forein_offers"
        :tender="tender"
        @openProlong="open"/>
    </template>
  </MenuItem>
</template>

<script>
import MenuItem from 'components/common/MenuItem.vue'
import DateChip from 'components/common/elements/DateChip.vue'
import TermsCard from 'components/tenders/tender creation/TermsCard.vue'
import DateRangeDialog from 'components/common/dialogs/DateRangeDialog.vue'
import DialogTemplateToolkit from 'components/common/dialogs/DialogTemplateToolkit.vue'
import ProlongTenderWithForeignOffers from 'components/tenders/dialogs/ProlongTenderWithForeignOffers.vue'

import { datePickerMixin, holidaysMixin, modalMixin, tenderMixin } from 'mixins'
import SmarttenderApi from '@/api/smarttenderApi'
import { getMinProposalsDate } from '@/plugins/tenderDates.js'
import { eventBus } from '@/main'
import { mapGetters } from 'vuex'

const api = new SmarttenderApi()
import moment from 'moment'

export default {
  name: 'prolongTender',
  mixins: [ tenderMixin, datePickerMixin, modalMixin, holidaysMixin ],
  data() {
    const that = this
    return {
      dialog: false,
      sendApi: false,
      loading: false,
      tooltip_text: '',
      oldProposalDate: null,
      rules: {
        'proposal.date': [
          {
            type: 'object',
            trigger: 'change',
            required: true,
            validator(rule, value, callback) {
              if (new Date(value) < new Date()) {
                callback(new Error(that.$t('Validate.DateProposalMustMoreCurrent')))
              }
              if (!that.prolong && new Date(value) < new Date(that.oldProposalDate)) {
                callback(new Error(that.$t('Validate.dateMustMoreOld')))
              }
              if (moment(value).format('YYYY-MM-DD HH:mm') === that.$moment(that.oldProposalDate).format('YYYY-MM-DD HH:mm')) {
                callback(new Error(that.$t('Validate.InitialNeedsChanged')))
              }
              if (!that.tender.isUrgent && !that.prolong && new Date(value) < new Date(that.min_period_date)) {
                const errorText = that.$t('Validate.WrongProposalsDate',
                  {
                    date: that.$d(new Date(that.min_period_date), 'longDate'),
                    for: that.$t('Tenders.ForAcceptingProposals')
                  })
                callback(new Error(errorText))
              }
              if (!that.tender.isUrgent && that.prolong && that.minProlongDate && new Date(value) < that.minProlongDate) {
                const errorText = that.$t('Validate.WrongProposalsDate',
                  {
                    date: that.$d(that.minProlongDate, 'longDate'),
                    for: that.status == 7 ? that.$t('Tenders.OfAuction') : that.$t('Tenders.ForAcceptingProposals')
                  })
                callback(new Error(errorText))
              }
              callback()
            },
          }
        ],
        'deliveryDate.from': {
          trigger: 'change',
          validator: that.checkDeliveryDate,
        },
        'deliveryDate.to': {
          trigger: 'change',
          validator: that.checkDeliveryDate,
        },
        text: [
          {
            type: 'string',
            trigger: 'change',
            transform(value) {
              return value.trim()
            },
            validator(rule, value, callback) {
              if (that.isRepublish) { callback() }
              if (!value) {
                callback(new Error(that.$t('Tenders.ProlongReason')))
              }
              if (value.length < 10) {
                callback(new Error(that.$t('Validate.minLength', { number: 10, type: that.$tc('Common.characters', 10) })))
              }
              const words_length = value.split(' ').length
              if (words_length < 2) {
                callback(new Error(that.$t('Validate.minLength', { number: 2, type: that.$tc('Common.words', 2) })))
              }
              callback()
            },
          }
        ]
      },
      formData: {
        text: '',
        proposal: {
          date: null,
          time: null
        },
        deliveryDate: {
          from: null,
          to: null
        }
      }
    }
  },
  props: {
    tender: Object
  },
  computed: {
    ...mapGetters({
      tendersSettings: 'getTendersSettings',
    }),
    deliveryDateOptions() {
      return {
        from: {
          min: this.formData.proposal.date
        },
        to: {
          min: this.formData.proposal.date
        }
      }
    },
    deliveryDate() {
      const getLabel = (text) => {
        if (!text) { return '' }
        return this.$d(new Date(text), 'shortDate')
      }
      return {
        arrayDate: [this.formData.deliveryDate.from, this.formData.deliveryDate.to],
        fromLabel: getLabel(this.formData.deliveryDate.from),
        toLabel: getLabel(this.formData.deliveryDate.to),
      }
    },
    isRepublish( ) {
      return this.status == 11
    },
    status() {
      return this.tender.tenderStatus.id
    },
    is_multistaged() {
      return this.tender.biddingType?.isMultistage
    },
    without_publication() {
      return this.tender.biddingType?.withoutPublication
    },
    auction_endDate() {
      return this.tender.auctionPeriod?.endDate
    },
    /**
     * На аукціон повертає лише isReturnToAuction (Аналіз пропозицій багатоетапного тендеру). На Прекваліфікації
     * auctionPeriod.endDate може бути заповнений ще до проведення аукціону (відхилене узгодження публікації
     * аукціону), але кнопка повертає тендер на Прийом пропозицій.
     * https://app.clickup.com/t/869fk94dv
     */
    return_to_status() {
      return this.status == 3 && this.is_multistaged ? this.$t('Tenders.Auction') : this.$t('Tenders.AcceptingOffers')
    },
    prolong() {
      //  AVAILABLETENDERPROLONGATION
      // 0: {statusCode: 1, title: "Реєстрація", __typename: "TenderStatusGraph"}
      // 1: {statusCode: 3, title: "Аналіз пропозицій", __typename: "TenderStatusGraph"}
      // 2: {statusCode: 4, title: "Прийом пропозицій", __typename: "TenderStatusGraph"}
      // 3: {statusCode: 5, title: "Прекваліфікація", __typename: "TenderStatusGraph"}
      // 4: {statusCode: 7, title: "Аукціон", __typename: "TenderStatusGraph"}
      // 5: {statusCode: 8, title: "Кваліфікація", __typename: "TenderStatusGraph"}
      // 6: {statusCode: 9, title: "Пропозиції розглянуті", __typename: "TenderStatusGraph"}
      // 7: {statusCode: 10, title: "Завершено", __typename: "TenderStatusGraph"}
      // 8: {statusCode: 11, title: "Закупівля не відбулась", __typename: "TenderStatusGraph"}
      // 9: {statusCode: 12, title: "Закупівля відмінена", __typename: "TenderStatusGraph"}
      return this.$can('prolong', 'Tender') && (this.status == 7 || this.status == 4)
    },
    /**
     * Мінімальна дата, доступна при продовженні прийому пропозицій/аукціону — не менше
     * ніж старт відповідного періоду + мінімальна кількість днів перебування тендеру на сайті.
     */
    minProlongDate() {
      if (!this.prolong) { return null }
      const daysWebTender = this.tendersSettings?.daysWebTender
      const startDate = this.status == 7 ? this.tender.auctionPeriod?.startDate : this.tender.tenderPeriod?.startDate
      if (!startDate) { return null }
      const date = getMinProposalsDate(daysWebTender, startDate)
      // formData.proposal.date завжди зберігається з секундами :00 (див. TermsCard.updateDate) - округлюємо
      // поріг вгору до цілої хвилини, щоб дата/час, підказані як мінімальні, самі проходили валідацію
      if (date.getSeconds() || date.getMilliseconds()) {
        date.setMinutes(date.getMinutes() + 1)
      }
      date.setSeconds(0, 0)
      return date
    },
    /**
     * Мінімальна дата в календарі. При продовженні - minProlongDate (але не раніше сьогодні), інакше
     * null, і TermsCard бере мінімум для нового тендеру (від поточного моменту, а не від дати публікації).
     */
    pickerMinDate() {
      const now = new Date()
      if (this.tender.isUrgent) { return now }
      if (!this.minProlongDate) { return null }
      return this.minProlongDate > now ? this.minProlongDate : now
    },
    /**
     * https://app.clickup.com/t/8696n7crh
     */
    isReturnToAuction() {
      return this.status === 3 && this.is_multistaged && this.$can('return', 'TenderToSite')
    },
    return_to_site() {
      const defaultLogic = this.$can('return', 'TenderToSite') && (this.isRepublish || this.status == 3 || this.status == 5)
      return this.isReturnToAuction || defaultLogic
    },
    hideMenu() {
      if (this.without_publication) {
        return true
      }
      if (this.isReturnToAuction) {
        return false
      }
      if (this.status == 3 && this.is_multistaged && !this.auction_endDate ) {
        // this.tooltip_text = this.$t('Tenders.ImpossibleToExtendAuction')
        return true
      }

      // =
      const getAgoDate = () => {
        let dayDiff = 30
        try {
          const settings = this.tendersSettings?.maxProlongationPeriod
          if (settings) {
            dayDiff = settings / 60 / 60 / 24
          }
        } catch (er) {
          dayDiff = 30
        }
        return moment().subtract(dayDiff, 'days').format('YYYY-MM-DD')
      }

      const ago = getAgoDate()
      const tender_eding =  moment(this.auction_endDate ? this.auction_endDate : this.tender.tenderPeriod?.endDate)
      const too_old = moment(tender_eding).isBefore(ago)
      if ( (this.status == 3 || this.status == 5 ) && too_old) {
        // this.tooltip_text = this.$t('Tenders.IsTooOldToReturnToSite')
        return true
      }

      if (this.isRepublish && this.tender.hasBids) {
        // this.tooltip_text = this.$t('Tenders.CantReturnTenderWitharticipants')
        return true
      }
      return false
    }
  },
  methods: {
    /**
     * Костыль, что б самописные компоненты вызывали trigger: 'change' у FormItem
     */
    sendChangeFormItem(refName, value) {
      this.$refs[refName].$emit.apply(this.$refs[refName], ['s.form.change'].concat(value))
    },
    setDeliveryDate(value) {
      this.formData.deliveryDate.from = value[0] || null
      this.formData.deliveryDate.to = value[1] || null
      this.sendChangeFormItem('formItemDeliveryDateFrom', this.formData.deliveryDate.from)
      this.sendChangeFormItem('formItemDeliveryDateTo', this.formData.deliveryDate.to)
    },
    checkDeliveryDate(rule, value, callback) {
      const deliveryDate = value ? new Date(value) : null
      const proposalDate = new Date(this.formData.proposal.date)
      if (deliveryDate && deliveryDate.getDateWithoutTime() < proposalDate.getDateWithoutTime()) {
        const text = this.$t('Validate.WrongProposalsDate', { date: this.$d(proposalDate, 'shortDate') })
        callback(new Error(text))
      }
      callback()
    },
    cancel( ) {
      this.formData.text = ''
      this.dialog =  false
    },
    submit() {
      this.$store.dispatch('setMinPproposalsDate')
      this.$refs.prolongTenderForm.validate((valid) => {
        if (!valid) { return }
        let date_to = this.formData.deliveryDate.to ? moment(this.formData.deliveryDate.to ).format('YYYY-MM-DD') : null,
          date_from = this.formData.deliveryDate.from ? moment(this.formData.deliveryDate.from ).format('YYYY-MM-DD') : null,
          date = this.formData.proposal.date,
          obj = {
            tenderingPeriodEnd: date,
            deliveryPeriodStart: date_from,
            deliveryPeriodEnd: date_to
          }
        try {
          this.loading = true

          let apiMethod = api.prolongTender
          let model = {
            ...obj,
            reason: this.formData.text
          }

          if (this.isReturnToAuction) {
            apiMethod = api.returnToAuction
          } else if (this.isRepublish) {
            apiMethod = api.republishTender
            model = {
              ...obj,
              tenderId: this.tender.tenderId
            }
          }
          this.sendApi = true
          apiMethod({
            tenderId: this.tender.tenderId,
            model
          }).then(res => {
            if (!res?.success) {
              throw res.messages
            } else {
              eventBus.$emit('tenderUpdate', true)
              this.cancel()
            }
          })
            .catch(error => {
              this.$notice.error({
                title: this.$t('Common.ErrorTitle'),
                message: error,
                duration: 10,
              })
              this.$log_error(error?.message || error)
            })
            .finally(() => {
              this.sendApi = false
            })

        } catch (error) {
          this.$log_error(error.message)
        }
        this.loading = false
      })
    },
    getMinDate(inputDate) {
      let date = moment( inputDate ).add(3, 'd')
      date.set('hour', '15')
      date.set('minute', '00')
      date.set('second', '00')

      while (!this.$_allowedDates(date.format())) {
        date.add(1, 'd')
      }
      return date.format('YYYY-MM-DDTHH:mm:ss')
    },
    open() {
      if ( this.tender.bids.some(bid => bid.foreignBidderBid)) { //todo external
        this.$refs.forein_offers?.open()
        return
      }
      let that = this
      setTimeout(() => {
        this.oldProposalDate = that.auction_endDate || that.tender.tenderPeriod?.endDate
        if (new Date(this.oldProposalDate) < new Date()) {
          that.formData.proposal.date = this.getMinDate()
        } else {
          that.formData.proposal.date = this.oldProposalDate
        }

        if (that.minProlongDate && new Date(that.formData.proposal.date) < that.minProlongDate) {
          that.formData.proposal.date = that.minProlongDate
        }

        that.formData.proposal.time = moment(that.formData.proposal.date).format('HH:mm')

        const deliveryDateTo = that.tender.deliveryPeriod?.endDate || null,
          deliveryDateFrom = that.tender.deliveryPeriod?.startDate || null,
          date_deliveryDateTo = new Date(deliveryDateTo).getDateWithoutTime(),
          date_deliveryDateFrom = new Date(deliveryDateFrom).getDateWithoutTime(),
          date_prop = new Date(that.formData.proposal.date).getDateWithoutTime(),
          validDeliveryDateTo = deliveryDateTo && date_deliveryDateTo >= date_prop ,
          validDeliveryDateFrom =  deliveryDateFrom && date_deliveryDateFrom >= date_prop  && date_deliveryDateFrom <= date_deliveryDateTo

        that.formData.deliveryDate.to = validDeliveryDateTo ? that.tender.deliveryPeriod?.endDate : null
        that.formData.deliveryDate.from = validDeliveryDateFrom ? that.tender.deliveryPeriod?.startDate : null
        that.dialog = true
      }, 100)
    }
  },
  components: {
    MenuItem,
    DateChip,
    TermsCard,
    DateRangeDialog,
    DialogTemplateToolkit,
    ProlongTenderWithForeignOffers
  }
}
</script>
<style lang="scss" scoped>
.reason-row {
  width: 100%;
}
.textarea {
  width: 100%;
}
</style>
